import { createSelector } from 'reselect';
import ReceptaclesInPredesNotInPreconSummaryColumns
  from '../../containers/ReceptaclesInPredesNotInPreconSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclesInPredesNotInPreconSummaryColumns);
